import { Accordion as AccordionPrimitive } from 'radix-ui';
import * as React from 'react';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './components/ui/accordion.js';
import { cn } from './lib/utils.js';

export function DimeAccordion({ ...props }: Readonly<React.ComponentProps<typeof Accordion>>) {
  return <Accordion {...props} />;
}

export function DimeAccordionItem({
  ...props
}: Readonly<React.ComponentProps<typeof AccordionItem>>) {
  return <AccordionItem {...props} />;
}

export function DimeAccordionTrigger({
  asChild,
  children,
  ...props
}: Readonly<React.ComponentProps<typeof AccordionTrigger>>) {
  if (asChild) {
    return (
      // A custom trigger is an icon toggle, not a section title, so its header must not be an empty h3.
      <AccordionPrimitive.Header asChild>
        <div className="flex">
          <AccordionPrimitive.Trigger asChild data-slot="accordion-trigger" {...props}>
            {children}
          </AccordionPrimitive.Trigger>
        </div>
      </AccordionPrimitive.Header>
    );
  }

  return <AccordionTrigger {...props}>{children}</AccordionTrigger>;
}

export function DimeAccordionContent({
  className,
  ...props
}: Readonly<React.ComponentProps<typeof AccordionContent>>) {
  return (
    <AccordionContent className={cn('h-auto [&_p:not(:last-child)]:mb-0', className)} {...props} />
  );
}
